/** Carousel-only photos. Keep hero readings on their original media.
 * Prefer the test's own photography; reserve the shared portrait series for
 * low-resolution originals and pages without a dedicated photo collection.
 */
const portrait = (scene: string) => `/images/questions/${scene}-20261001.webp`
const refreshed = (scene: string) =>
  `/images/questions/${scene}-fresh-20261001.webp`
const original = (file: string) => `/images/questions/${file}`

const photos: Record<string, string[]> = {
  "full-body-mri": [
    portrait("man-walk"),
    portrait("man-read"),
    portrait("woman-walk"),
    portrait("man-stretch"),
  ],
  "prevention-starter": [
    portrait("blood-dizzy-sunlight"),
    original("blood-colds.jpeg"),
    original("blood-winter-blues.jpg"),
    portrait("blood-tired-sunlight"),
  ],
  "calcium-score": [
    portrait("man-walk"),
    portrait("woman-window"),
    portrait("man-read"),
    portrait("man-stretch"),
  ],
  "dexa-scan": [
    original("body-aging.jpeg"),
    original("brain-aging.jpeg"),
    portrait("woman-strength"),
    portrait("man-strength"),
  ],
  "gender-health": [
    portrait("man-read"),
    portrait("woman-focus"),
    original("body-diet.jpeg"),
    original("body-aging.jpeg"),
  ],
  "prostate-mri": [
    portrait("man-read"),
    portrait("man-walk"),
    portrait("man-stretch"),
    portrait("man-strength"),
  ],
  "pelvic-mri": [
    portrait("woman-window"),
    portrait("woman-focus"),
    "/images/questions/hormone-w-mood-quality-v2-20261002.webp",
    portrait("woman-strength"),
  ],
  "essential-b-vitamins-test": [
    refreshed("bvitamin-focus"),
    refreshed("bvitamin-mood"),
    refreshed("bvitamin-skin"),
    portrait("blood-tired-sunlight"),
  ],
  "omega-blood-test": [
    "/images/questions/omega-supplement-quality-v2-20261001.webp",
    refreshed("omega-nutrients"),
    "/images/questions/omega-skin-quality-v2-20261001.webp",
    original("omega-joints.jpg"),
  ],
  "hormone-blood-test-women": [
    refreshed("hormone-w-stress"),
    "/images/questions/hormone-w-mood-quality-v2-20261002.webp",
    "/images/questions/hormone-w-training-quality-v2-20261002.webp",
    "/images/questions/hormone-w-menopause-soft-background-v3-20261002.webp",
  ],
  "hormone-blood-test-men": [
    refreshed("hormone-m-stress"),
    original("hormone-m-training.jpeg"),
    original("hormone-m-estrogen.jpeg"),
    original("hormone-m-energy.jpg"),
  ],
}

export function questionCarouselPhoto(
  testSlug: string,
  index: number,
  fallback: string
) {
  return photos[testSlug]?.[index] ?? fallback
}
